import React from 'react';
import styled from '@emotion/styled';

type SVG = {
  fill?: string;
  isActive?: boolean;
  width?: string;
};

export const ArrowForward = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="20px"
    viewBox="0 0 24 24"
    width="20px"
    fill="#000000"
  >
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" />
  </svg>
);

export const DownArrow = () => (
  <svg
    height="28px"
    width="28px"
    fill={`${(p: any) => p.theme.colors.primary}`}
    viewBox="0 0 24 24"
    stroke="none"
  >
    <g>
      <path d="M24 24H0V0h24v24z" fill="none" opacity=".87" />
      <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41z" />
    </g>
  </svg>
);

export const EmailIcon = (props: SVG) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path className="a" d="M0,0H24V24H0Z" />
    <path
      fill={`${props.fill}`}
      d="M20,4H4A2,2,0,0,0,2.01,6L2,18a2.006,2.006,0,0,0,2,2H20a2.006,2.006,0,0,0,2-2V6A2.006,2.006,0,0,0,20,4Zm-.4,4.25-7.07,4.42a1.011,1.011,0,0,1-1.06,0L4.4,8.25a.849.849,0,1,1,.9-1.44L12,11l6.7-4.19a.849.849,0,1,1,.9,1.44Z"
    />
  </svg>
);

export const ExternalLink = (props: SVG) => (
  <ExternalLinkSVG
    height="24px"
    width="24px"
    fill={`${props.fill}`}
    stroke="none"
    viewBox="0 0 24 24"
  >
    <g>
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z" />
    </g>
  </ExternalLinkSVG>
);

const ExternalLinkSVG = styled.svg`
  margin-left: 10px;
`;

export const FirstPage = (props: SVG) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 0 24 24"
    width="24px"
    fill={`${props.isActive === true ? '#000' : '#00000033'}`}
  >
    <path d="M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z" />
    <path d="M24 24H0V0h24v24z" fill="none" />
  </svg>
);

export const LastPage = (props: SVG) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 0 24 24"
    width="24px"
    fill={`${props.isActive === true ? '#000' : '#00000033'}`}
  >
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path d="M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z" />
  </svg>
);

export const MarkerIcon = (props: SVG) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ? props.width : '48'}
    height={props.width ? props.width : '48'}
    viewBox="0 0 48 48"
  >
    <g transform="translate(0.472 0.472)">
      <rect
        className="a"
        width="48"
        height="48"
        fill="none"
        transform="translate(-0.472 -0.472)"
      />
      <g transform="translate(7.921 3.961)">
        <path
          className="b"
          fill={`${props.fill}`}
          d="M19.843,2A15.753,15.753,0,0,0,4,18.239q0,9.446,14.536,22.239a2.014,2.014,0,0,0,2.634,0q14.5-12.8,14.516-22.239A15.753,15.753,0,0,0,19.843,2Zm0,19.8A3.961,3.961,0,1,1,23.8,17.843,3.972,3.972,0,0,1,19.843,21.8Z"
          transform="translate(-4 -2)"
        />
      </g>
    </g>
  </svg>
);

export const Menu = () => (
  <svg
    id="Capa_1"
    enableBackground="new 0 0 464.205 464.205"
    height="24"
    width="24"
    viewBox="0 0 464.205 464.205"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <g id="grip-solid-horizontal_1_">
        <path d="m435.192 406.18h-406.179c-16.024 0-29.013-12.99-29.013-29.013s12.989-29.013 29.013-29.013h406.18c16.023 0 29.013 12.99 29.013 29.013-.001 16.023-12.99 29.013-29.014 29.013z" />
        <path d="m435.192 261.115h-406.179c-16.024 0-29.013-12.989-29.013-29.012s12.989-29.013 29.013-29.013h406.18c16.023 0 29.013 12.989 29.013 29.013s-12.99 29.012-29.014 29.012z" />
        <path d="m435.192 116.051h-406.179c-16.024 0-29.013-12.989-29.013-29.013s12.989-29.013 29.013-29.013h406.18c16.023 0 29.013 12.989 29.013 29.013s-12.99 29.013-29.014 29.013z" />
      </g>
    </g>
  </svg>
);

export const NextPage = (props: SVG) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="40px"
    viewBox="0 0 24 24"
    width={`${props.width || '40'}px`}
    fill={`${props.fill}`}
  >
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
  </svg>
);

export const PreviousPage = (props: SVG) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="40px"
    viewBox="0 0 24 24"
    width="40px"
    fill="#0B2341"
  >
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
  </svg>
);

export const BigNextPage = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#0B2341">
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
  </svg>
);

export const BigPreviousPage = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#0B2341">
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
  </svg>
);

export const PhoneIcon = ({
  fill,
  width,
}: {
  fill: string | any;
  width?: string | any;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width || '24px'}
    height={width || '24px'}
    viewBox="0 0 27.51 27.51"
    fill="none"
  >
    <path className="a" d="M0,0H27.51V27.51H0Z" />
    <path
      stroke="#000"
      fill={fill || '#000'}
      d="M21.6,17.052l-2.911-.332a2.282,2.282,0,0,0-1.88.653L14.7,19.482a17.246,17.246,0,0,1-7.554-7.554L9.266,9.807a2.282,2.282,0,0,0,.653-1.88L9.587,5.039A2.294,2.294,0,0,0,7.306,3.01H5.323A2.275,2.275,0,0,0,3.031,5.383,19.477,19.477,0,0,0,21.244,23.6,2.275,2.275,0,0,0,23.617,21.3V19.321A2.272,2.272,0,0,0,21.6,17.052Z"
      transform="translate(0.443 0.44)"
    />
  </svg>
);

export const Quote = ({ width }: string | any) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={width}
    viewBox="0 0 351.128 351.128"
  >
    <path
      d="M72.326,147.33c4.284-26.928,37.944-55.692,64.26-56.304c1.836,0,3.672-0.612,4.896-1.836
		c1.224-0.612,2.448-1.224,3.06-3.06c9.18-17.136,4.284-30.6-11.016-41.616c-17.748-12.852-45.9,0-59.976,11.628
		C38.054,85.518,1.946,136.313,3.782,184.662c-6.12,32.437-4.896,67.32,4.284,96.084c6.12,18.36,23.868,27.54,42.228,28.764
		c18.36,1.225,56.304,6.732,72.828-4.283c16.524-11.017,17.748-32.437,19.584-50.796c1.836-20.196,7.344-58.141-9.792-74.053
		C115.778,165.078,66.818,181.602,72.326,147.33z"
    />
    <path
      d="M274.286,147.33c4.284-26.928,37.943-55.692,64.26-56.304c1.836,0,3.672-0.612,4.896-1.836
		c1.225-0.612,2.448-1.224,3.061-3.06c9.18-17.136,4.284-30.6-11.016-41.616c-17.748-12.852-45.9,0-59.977,11.628
		c-35.496,29.376-71.604,80.172-69.768,128.52c-6.12,32.437-4.896,67.32,4.283,96.084c6.12,18.36,23.868,27.54,42.229,28.764
		c18.36,1.225,56.304,6.732,72.828-4.283c16.523-11.017,17.748-32.437,19.584-50.796c1.836-20.196,7.344-58.141-9.792-74.053
		C317.738,165.078,268.166,181.602,274.286,147.33z"
    />
  </svg>
);

export const Refresh = () => (
  <svg
    height="24px"
    width="24px"
    fill="#325C79"
    stroke="none"
    viewBox="0 0 24 24"
  >
    <g>
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z" />
    </g>
  </svg>
);

export const RightArrow = () => (
  <svg
    height="28px"
    width="28px"
    fill="white"
    viewBox="0 0 24 24"
    stroke="none"
  >
    <g>
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6z" />
    </g>
  </svg>
);

export const Search = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28.682"
    height="28.682"
    viewBox="0 0 28.682 28.682"
    fill="none"
  >
    <path className="a" d="M0,0H28.682V28.682H0Z" />
    <path
      className="b"
      fill="#000"
      d="M17.939,16.146h-.944l-.335-.323a7.79,7.79,0,1,0-.837.837l.323.335v.944l5.079,5.079a1.259,1.259,0,0,0,1.781-1.781Zm-7.17,0a5.378,5.378,0,1,1,5.378-5.378A5.371,5.371,0,0,1,10.768,16.146Z"
      transform="translate(0.585 0.585)"
    />
  </svg>
);

export const StrongUnderline = ({
  width,
  translateY,
  translateX,
}: {
  width: number;
  translateY?: number;
  translateX?: number;
}) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 670.97 117.73"
    style={{
      width: width,
      transform: `translate(${translateX || 0}px, ${translateY || 0}px)`,
    }}
  >
    <g>
      <g>
        <path
          className="st0"
          fill="#7FADED"
          d="M182.65,41.13c58.42-1.16,116.85-1.58,175.28-1.25c58.43,0.33,116.85,1.41,175.25,3.24
			c32.77,1.02,65.54,2.29,98.29,3.78c0-1.84,0-3.68,0-5.52c-80.05-1.98-160.16-1.37-240.17,1.87
			c-80.01,3.24-159.91,9.09-239.53,17.54c-44.62,4.73-89.15,10.3-133.57,16.65c-3.1,0.44-2.33,5.51,0.73,5.42
			c82.42-2.37,164.85-5.01,247.29-6.7c82.15-1.68,164.34-2.25,246.48,0.12c46.49,1.35,92.96,3.65,139.34,7.21c0-1.84,0-3.68,0-5.52
			c-78.95-4.58-157.9-9.16-236.94-11.89c-78.94-2.73-157.97-3.63-236.92-0.83c-44.25,1.57-88.46,4.31-132.54,8.5
			c-3.56,0.34-3.54,5.14,0,5.52c36.5,3.9,73.19,1.66,109.74-0.26c36.98-1.93,73.99-3.19,111-4.09
			c73.99-1.81,148.01-2.22,222.01-3.92c41.64-0.96,83.28-2.33,124.88-4.57c3.53-0.19,3.56-5.71,0-5.52
			c-73.94,3.98-147.98,5.2-222.01,6.28c-74.02,1.09-148.06,2.06-222.01,5.6c-41.16,1.97-82.48,5.34-123.61,0.95
			c0,1.84,0,3.68,0,5.52c78.61-7.48,157.59-10.29,236.53-10.21c79.06,0.09,158.09,3.05,237.04,7.05
			c44.29,2.24,88.56,4.81,132.84,7.38c3.56,0.21,3.51-5.25,0-5.52c-82.32-6.31-164.9-8.64-247.45-8.79
			c-82.2-0.14-164.38,1.86-246.54,4.17C111.67,74.64,65.3,76,18.93,77.33c0.24,1.81,0.49,3.62,0.73,5.42
			c79.23-11.33,158.83-20.06,238.63-26.19c79.42-6.1,159.04-9.62,238.69-10.55c44.83-0.52,89.67-0.22,134.49,0.89
			c3.56,0.09,3.54-5.36,0-5.52c-58.37-2.66-116.77-4.58-175.19-5.75c-58.42-1.17-116.85-1.59-175.28-1.27
			c-32.79,0.18-65.57,0.6-98.35,1.25C179.1,35.68,179.09,41.2,182.65,41.13L182.65,41.13z"
        />
      </g>
    </g>
  </svg>
);

export const FamilyClinic = () => (
  <svg
    id="Group_683"
    data-name="Group 683"
    xmlns="http://www.w3.org/2000/svg"
    width="120"
    height="17"
    viewBox="0 0 433.542 70.175"
    fill="none"
  >
    <path
      id="Path_828"
      data-name="Path 828"
      d="M839.276,148.1c0-15.036-15.531-20.049-26.685-20.049a35.854,35.854,0,0,0-16.1,3.6c-7.13,3.6-14.825,10.517-14.825,19.064v1.411c0,1.411,2.191,6.141,3.955,7.836a13.738,13.738,0,0,0,8.679,3.176H796c2.049-.284,3.46-1.132,3.387-3.46-.564-1.343.353-2.681-1.764-3.46-4.871-.284-8.4-.985-8.4-5.361,0-11.649,19.98-15.251,26.4-15.531,0,0,.637,0,.637.284-6.846,5.719-10.733,19.27-13.7,26.616-3.813,7.552-7.346,21.108-14.472,21.108-2.328,0-3.318-3.671-6-3.671a2.226,2.226,0,0,0-.946.235,3.436,3.436,0,0,0-1.426,4.822c1.382,2.406,3.93,5.19,6.116,5.675a10.886,10.886,0,0,0,1.553.142c4.94,0,10.027-2.754,13.835-8.047a58.432,58.432,0,0,0,5.72-11.017l.705-2.117a85.947,85.947,0,0,1,3.318-8.4c.279,0,1.622,1.553,2.539,2.117a11.953,11.953,0,0,0,6.7,1.906C829.818,164.973,839.276,157.563,839.276,148.1Zm-18.848,9.743c-1.412,0-7.484-1.343-7.484-2.328a5.021,5.021,0,0,1,.142-.921c1.906-5.509,5.435-12.424,11.649-15.884,6.214,1.269,7.13,4.45,7.13,7.626C831.866,152.054,826.715,157.842,820.428,157.842Z"
      transform="translate(-779.242 -120.366)"
      fill="#0b2341"
    />
    <path
      id="Path_829"
      data-name="Path 829"
      d="M1295.52,139.824c2.259,0,4.591-3.039,4.591-5.224,0-4.024-2.611-7.2-6.424-7.131a4.874,4.874,0,0,0-3.313,1.3,6.333,6.333,0,0,0-.23,9.076A7.213,7.213,0,0,0,1295.52,139.824Z"
      transform="translate(-1038.84 -120.069)"
      fill="#0b2341"
    />
    <path
      id="Path_830"
      data-name="Path 830"
      d="M1421.939,139.824c2.259,0,4.593-3.039,4.593-5.224,0-4.024-2.612-7.2-6.425-7.131a4.876,4.876,0,0,0-3.313,1.3,6.334,6.334,0,0,0-.229,9.076A7.213,7.213,0,0,0,1421.939,139.824Z"
      transform="translate(-1103.304 -120.069)"
      fill="#0b2341"
    />
    <path
      id="Path_831"
      data-name="Path 831"
      d="M1084.233,164.544l-.392.627c-1.622,2.191-4.023,6.425-8.68,7.341-1.342.421-4.518-.706-3.46-3.46.917-4.871,3.387-9.6,6.283-13.908l2.9-4.308a3.513,3.513,0,0,0,.564-2.191c0-2.47-.633-4.161-2.117-4.161-1.975,0-4.588,2.9-5.22,4.161-.921,1.838-1.906,2.754-3.249,5.651a43.781,43.781,0,0,0-2.353,4.533c-1.916,1.269-4.553,4.641-5.552,5.915-1.48,1.906-6.214,7.057-8.611,7.273-2.47-.284-3.176-3.318-2.754-4.519l.215-.495c1.059-2.049,4.093-9.037,4.377-9.459,5.93-2.117,13.2-9.106,16.869-14.894,2.612-4.092,7.414-13.835,7.625-19.554.03-1.411.064-2.475,0-3.445a8.751,8.751,0,0,0-3.4-6.337,3.936,3.936,0,0,0-2.245-.946c-6.14,0-12.566,11.581-15.673,18.569-3.391,6.665-7.974,18.878-11.213,27.969a11.231,11.231,0,0,0-2.47,3.024,41.544,41.544,0,0,1-6.7,7.2c-2.809,2.4-5.71,4.411-8.15,5.107a3.677,3.677,0,0,1-2.955-.387c-.255-.162-.451-.333-.47-.485a40.445,40.445,0,0,1-1.838-11.365c1.343-1.48,10.517-5.577,14.545-6.989,1.059-.353,1.622.706,2.754.5,1.764-.5,2.539-2.259,2.681-4.8-.421-3.034-3.671-3.671-4.94-3.739s-8.121,3.244-9.18,4.024c-3.955,1.906-9.105,4.024-12.919,6.567a34.414,34.414,0,0,1,1.48-3.455c5.93-3.039,13.7-9.6,16.942-14.683,2.613-4.092,5.857-10.591,6.072-16.31.03-1.411.064-2.475,0-3.445a8.762,8.762,0,0,0-3.4-6.342,3.936,3.936,0,0,0-2.24-.946c-6.14,0-12.565,11.581-15.672,18.569-3.029,6-8.41,19.515-12.482,31.262-2.906.76-7.969,6.552-12.149,9.047a13.779,13.779,0,0,1-9.106,2.4c-2.328-.637-3.107-4.234-2.328-5.577h2.117c6,0,14.261-5.93,16.521-8.9a18.294,18.294,0,0,0,4.234-9.738c.353-2.191-.848-7.836-4.734-7.91-5.366-.142-11.155,1.906-14.756,5.509-4.745,5.028-7.356,9.468-8.793,14.526-1.3,1.661-2.557,3.465-2.636,3.622-1.133,2.259-5.3,7.273-7.91,7.273-1.833,0-1.411-3.318-.985-4.519,2.117-5.788,4.161-9.037,5.719-13.413l.284-1.98a5.54,5.54,0,0,0-5.509-5.788h-.422a24.241,24.241,0,0,0,7.552-7.131c2.613-4.092,5.93-10.8,6.14-16.521.035-1.411.064-2.475,0-3.445a8.751,8.751,0,0,0-3.4-6.337,3.957,3.957,0,0,0-2.245-.951c-6.141,0-12.566,11.581-15.673,18.569-3.69,7.273-9.331,21.284-12.875,30.655a59.169,59.169,0,0,1-5.337,6.41c-3.812,3.6-7.483,6.141-8.684,4.729-.421-.564-.495-1.48.216-3.034l1.48-3.038a58.067,58.067,0,0,1,5.651-9.321v.069a13.912,13.912,0,0,0,1.411-1.764l5.788-7.562a5.95,5.95,0,0,0,.706-1.191h0c.005,0,.005-.01.01-.015a2.79,2.79,0,0,0-1.441-4.1,3.874,3.874,0,0,0-1.25-.191,4.1,4.1,0,0,0-3.886,1.975h.073a9.884,9.884,0,0,1-6.92,3.038c-1.558-.015-1.906-1.059-2.259-1.269l1.127-1.622c1.48-2.049,3.249-5.435,3.107-7.626-.073-1.622-2.685-2.544-4.45-2.544a9.47,9.47,0,0,0-5.93,2.686c-1.691,2.049-4.023,5.224-3.812,8.611.073,1.059.921,1.553.99,2.259.073,1.063-3.744,6.5-4.234,7.415-.863,1.446-1.813,2.95-2.793,4.4a26.4,26.4,0,0,1-4.823,5.362,65.447,65.447,0,0,1-7.488,5.984,13.778,13.778,0,0,1-9.106,2.4c-2.328-.637-3.107-4.234-2.328-5.577h2.117c6,0,14.261-5.93,16.521-8.9a18.3,18.3,0,0,0,4.234-9.738c.352-2.191-.848-7.836-4.735-7.91a20.817,20.817,0,0,0-14.756,5.509c-7.062,7.484-9.458,13.629-10.169,22.524-.564,5.646,5.082,9.953,7.625,10.022a21.814,21.814,0,0,0,11.791-2.681,54.346,54.346,0,0,0,16.8-14.472c4.352-5.812,6.283-10.238,6.7-10.169.99.353,2.613,1.411,3.955,1.343.99,0,2.328-.353,3.318-.422l.068.564A74.871,74.871,0,0,0,930.24,164.4a28.16,28.16,0,0,0-2.818,6.974,13.023,13.023,0,0,0-.564,3.994c.142,1.7,2.191,3.6,4.234,3.955a16.908,16.908,0,0,0,11.223-3.176c.015-.01.024-.02.039-.029-.009.059-.034.113-.044.171.353,1.833,1.411,3.386,3.318,3.386,2.1,0,3.279-3.078,4.254-4.509.406-.6.814-1.2,1.171-1.828,2.5-4.362,3.283-5.989,3.543-6.44l1.412-2.754c4.587-7.483,3.886-5.93,5.224-7.626.774-1.059,3.038-1.838,4.092-1.975,1.554-.216.99,3.107-.142,5.719a29.721,29.721,0,0,0-1.48,4.161L963,166.612a11.914,11.914,0,0,0-.774,4.024l.068,1.906c0,.353.216.99.216,1.411,0,1.411,2.47,5.293,5.577,5.293,3.6,0,7.483-3.744,9.39-5.366.475-.544.995-1.161,1.524-1.8.961,4.362,5.288,7.459,7.435,7.518a24.129,24.129,0,0,0,11.792-2.681,40.089,40.089,0,0,0,7.635-5.489l-.225.544c-.843,1.622-2.47,4.092-1.975,6,.422,1.554,3.318,1.98,5.082,1.838.039,0,.172-.02.333-.044a2.188,2.188,0,0,0,1.6-1.162,10.743,10.743,0,0,0,1.176-3.945c.632-1.411.142-.637.706-1.627a22.9,22.9,0,0,1,5.788-6.636,4.413,4.413,0,0,1,.985-.5c.074-.069.422.142.5.142a15.451,15.451,0,0,0,1.044,8.341c.181.421.368.838.51,1.274,1.23,3.651,5.523,5.072,9.1,5.072,1.837-.069,6.072-2.191,7.341-2.965a36.659,36.659,0,0,0,6.753-5.293,9.844,9.844,0,0,1,.368,1.48c0,1.411,3.739,5.293,7.552,5.293,2.886,0,5.842-1.632,8.062-3.205a23.912,23.912,0,0,0,4.225-3.857l.059-.069c-.02.353-.064.72-.064,1.054,0,5.082,5.5,6.288,9.459,6.288,5.234,0,12.958-7.6,16-14.134a37.915,37.915,0,0,1,2.705-4.827c.917-1.392,1.745-2.7,2.323-3.563.78-1.622,4.166-5.651,5.582-5.93,2.75.421-1.132,9.111-2.828,12.571-.917,1.2-1.48,4.092-2.538,5.788-.99,2.259-2.543,4.519-2.9,6.92.353,1.833,1.412,3.387,3.318,3.387,2.1,0,3.279-3.083,4.254-4.514.392-.573.784-1.152,1.136-1.745a35.489,35.489,0,0,1,3.082-4.685l1.412-2.754c4.592-7.484,4.94-7.057,6.287-8.753.775-1.059,3.318-3.671,4.377-3.813,1.548-.216.774,3.107-.353,5.719a52.487,52.487,0,0,0-2.117,5.293l-.706,2.191a11.345,11.345,0,0,0-.421,4.024l.069,1.906c0,.353-.142.99-.142,1.411,0,1.411,2.47,5.293,5.582,5.293,3.6,0,7.484-3.744,9.39-5.366.382-.436.8-.916,1.235-1.421-.01.235-.044.485-.044.711,0,5.082,5.5,6.288,9.459,6.288,2.2,0,4.827-1.353,7.371-3.382a3.882,3.882,0,0,0-.1,1.9c.421,1.554,3.317,1.98,5.082,1.838a.17.17,0,0,0,.044,0,2.485,2.485,0,0,0,1.975-1.387,12.083,12.083,0,0,0,.941-2.7,17.73,17.73,0,0,1,.48-1.887,2.113,2.113,0,0,1,.368-.809,22.97,22.97,0,0,1,5.788-6.636,4.34,4.34,0,0,1,.99-.495c.068-.069.422.142.495.142a15.431,15.431,0,0,0,1.049,8.336c.181.421.367.843.514,1.279,1.23,3.646,5.523,5.067,9.1,5.067,1.838-.069,6.072-2.191,7.346-2.965a39.808,39.808,0,0,0,4.073-2.887,5,5,0,0,0-.48,3.1c.422,1.554,3.318,1.98,5.083,1.838a.169.169,0,0,0,.044,0,2.486,2.486,0,0,0,1.975-1.387,10.519,10.519,0,0,0,1.083-3.764c.632-1.411.142-.637.706-1.627a22.9,22.9,0,0,1,5.788-6.636,4.427,4.427,0,0,1,.985-.495c.073-.069.422.142.495.142a15.461,15.461,0,0,0,1.411,9.111c.99,4.024,5.509,5.577,9.249,5.577,1.838-.069,6.072-2.191,7.341-2.965a36.667,36.667,0,0,0,6.7-5.244c.872,3.269,2.891,5.739,5.993,5.739,6,0,8.679-3.039,12.213-6.067,0-.142.563-.706.632-.779.211-.211,1.132-1.127,1.838-1.764a20.929,20.929,0,0,0-.216,2.544c0,2.048,3.107,6.425,5.857,6.425a13.806,13.806,0,0,0,6.557-2.191,26.469,26.469,0,0,0,8.126-7.5,11.773,11.773,0,0,0,2.553-6.111,1.538,1.538,0,0,0-.392-1.078l-.24-.274a1.48,1.48,0,0,0-1.406-.51,1.448,1.448,0,0,0-.755.446c-1.495,1.666-4.019,4.69-5.062,5.852-.99,1.127-5.3,4.94-8.047,4.3-.779-.284-1.269-2.612-1.269-3.671,0-2.9,1.549-5.788,3.318-8.263a22.017,22.017,0,0,0,2.191-2.965c.142-.284,3.6-5.509,3.6-7.131,0-1.059-.422-3.671-1.906-3.744a4.012,4.012,0,0,0-3.671,2.328,3.054,3.054,0,0,0-.656-1.059,6.966,6.966,0,0,0-5.366-2.681h-.049a22.552,22.552,0,0,0-15.672,6.567,35.673,35.673,0,0,0-7.4,11.468,41.426,41.426,0,0,1-6.356,6.748c-2.8,2.4-5.7,4.406-8.141,5.107a3.683,3.683,0,0,1-2.926-.358c-.274-.167-.49-.348-.51-.51a40.448,40.448,0,0,1-1.838-11.365c1.343-1.48,10.518-5.577,14.546-6.989,1.059-.353,1.622.706,2.755.495,1.764-.495,2.538-2.259,2.681-4.8-.422-3.034-3.671-3.671-4.94-3.739s-8.121,3.244-9.179,4.024c-3.955,1.906-9.106,4.024-12.919,6.567a34.323,34.323,0,0,1,1.481-3.455c5.93-3.039,13.7-9.6,16.942-14.683,2.612-4.092,5.857-10.591,6.072-16.31.068-3.176.142-4.592-.921-7.131-.774-1.132-2.892-3.6-4.729-3.6-6.141,0-12.566,11.581-15.673,18.569-2.754,5.46-7.449,17.119-11.341,28.018a11.724,11.724,0,0,0-2.411,2.97,41.528,41.528,0,0,1-6.7,7.2c-2.808,2.4-5.7,4.406-8.145,5.107a3.681,3.681,0,0,1-2.925-.358c-.275-.167-.49-.348-.515-.51a40.429,40.429,0,0,1-1.833-11.365c1.343-1.48,10.517-5.577,14.541-6.989,1.063-.353,1.622.706,2.754.495,1.764-.495,2.544-2.259,2.686-4.8-.422-3.034-3.676-3.671-4.94-3.739s-8.12,3.244-9.179,4.024c-3.956,1.906-9.111,4.024-12.919,6.567a37.064,37.064,0,0,1,1.48-3.455c5.93-3.038,13.7-9.6,16.947-14.683,2.607-4.092,5.857-10.591,6.068-16.31.034-1.411.063-2.475-.005-3.445a8.75,8.75,0,0,0-3.406-6.342,3.938,3.938,0,0,0-2.24-.946c-6.141,0-12.566,11.581-15.673,18.569-2.794,5.528-7.577,17.422-11.493,28.444h0a5.95,5.95,0,0,0-1.636,1.755l-2.539,4.038c-1.622,2.191-4.024,6.425-8.679,7.341-1.343.421-4.519-.706-3.459-3.46.916-4.871,3.386-9.6,6.282-13.909l2.9-4.308a3.51,3.51,0,0,0,.563-2.191c0-2.47-.632-4.161-2.117-4.161-1.975,0-4.587,2.9-5.219,4.161-.922,1.838-1.906,2.754-3.249,5.651a43.68,43.68,0,0,0-2.353,4.533c-1.975,1.21-4.641,5.655-4.769,5.915-1.059,2.117-5.856,7.131-7.694,7.273-1.411-.142-1.411-3.318-.985-4.518,2.117-5.788,3.955-10.664,5.5-15.041l.284-1.975a5.534,5.534,0,0,0-5.509-5.788,7.725,7.725,0,0,0-4.479,2.049,39.913,39.913,0,0,0-4.577,4.2l-2.093,2.225-1.7,2.191c-.049-.049.471-2.96.775-4.558a7.593,7.593,0,0,0-.044-3.269c-.466-1.857-1.618-3.328-3.911-3.328-4.592,0-9.322,4.3-11.865,8.331-1.215,1.941-2.274,3.627-3.216,5.043-.348.519-.676,1.054-.995,1.593ZM1202.7,143.353a67.111,67.111,0,0,1,3.886-9.037s3.147-7.253,5.381-10.419c.5-.715.975-1.456,1.441-2.2.833-1.338,1.677-1.98,2.568-1.926h.421c.848.495,1.2.848,1.132,2.686-.215,3.739-3.528,10.444-5.788,13.766-3.671,5.577-6.568,7.763-9.811,9.321Zm-37.756,0a67.642,67.642,0,0,1,3.882-9.037s3.151-7.258,5.386-10.424c.505-.716.976-1.451,1.44-2.2.838-1.338,1.681-1.98,2.569-1.926h.421c.843.495,1.2.848,1.128,2.686-.211,3.739-3.529,10.444-5.788,13.766-3.676,5.577-6.567,7.763-9.817,9.321Zm-105.24,1.838a97.743,97.743,0,0,1,4.8-10.875s3.146-7.253,5.381-10.419c.5-.715.975-1.456,1.441-2.2.833-1.338,1.676-1.98,2.568-1.926h.422c.847.495,1.2.848,1.132,2.686-.216,3.739-4.449,12.281-6.7,15.6-3.671,5.577-6.919,8.821-10.169,10.375Zm-36.982-.706a6.654,6.654,0,0,0,.211-1.132,67.048,67.048,0,0,1,3.886-9.037s3.146-7.253,5.381-10.419c.5-.715.975-1.456,1.441-2.2.833-1.338,1.676-1.98,2.568-1.926h.421c.848.495,1.2.848,1.133,2.686-.215,3.739-3.529,10.444-5.788,13.766-3.671,5.577-6.567,7.763-9.811,9.321C1022.929,143.5,1022.008,146.318,1022.718,144.485Zm-31.625,9.174c1.75-2.656,5.606-5.46,8.454-5.651a1.945,1.945,0,0,1,2.093,1.656,7.11,7.11,0,0,1-1.583,4.842c-1.838,3.107-8.4,7.341-13.2,7.974h-.069C987.28,159.379,989.329,156.2,991.093,153.659Zm-91.542,0c2.049-3.107,6.989-6.425,9.816-5.509,1.549,1.411.495,4.729-.848,6.356-1.837,3.107-8.4,7.341-13.2,7.974h-.069C895.738,159.379,897.786,156.2,899.551,153.659Zm61.829-7.552c.774-2.048.211-.284.916-2.117a6.075,6.075,0,0,0,.216-1.127,60.705,60.705,0,0,1,3.74-8.542s3.151-7.258,5.386-10.424c.5-.715.975-1.451,1.441-2.2.833-1.338,1.681-1.98,2.568-1.926h.421c.844.495,1.2.848,1.127,2.686-.211,3.739-2.965,9.248-5.225,12.566C968.3,140.6,964.629,144.554,961.38,146.107Zm288.609,5.93a6.394,6.394,0,0,1-1.226,3.759,85.623,85.623,0,0,1-7.812,9.581c-1.573,1.367-3.543,3.646-5.65,4.979a3.039,3.039,0,0,1-4.656-2.519v-.054c0-4.024,2.828-8.052,6.5-12.286,2.681-3.107,7.342-5.788,10.944-5.788.912,0,1.9,1.549,1.9,2.328Z"
      transform="translate(-834.302 -112.37)"
      fill="#0b2341"
    />
  </svg>
);

const SVG = styled.svg`
  margin-top: 24px;
`;
